/**
 * ConnectionRequests — inbound request list with accept/decline (Phase B, AC-07).
 */

import { useState } from 'react';
import { useSocialGraph } from '../../context/SocialGraphContext';
import { ProfileCardTrigger } from '../profile/ProfileCardTrigger';
import './ConnectionRequests.css';

export function ConnectionRequests() {
  const { inbound, accept, decline, isLoading } = useSocialGraph();
  const [busyId, setBusyId] = useState<string | null>(null);

  const act = async (id: string, fn: (id: string) => Promise<void>) => {
    setBusyId(id);
    try {
      await fn(id);
    } finally {
      setBusyId(null);
    }
  };

  if (isLoading && inbound.length === 0) {
    return <p className="connection-requests__empty">Loading requests…</p>;
  }
  if (inbound.length === 0) {
    return <p className="connection-requests__empty">No pending requests.</p>;
  }

  return (
    <ul className="connection-requests">
      {inbound.map((req) => (
        <li className="connection-requests__row" key={req.id}>
          <ProfileCardTrigger profileId={req.initiatorProfileId}>
            <span className="connection-requests__who">Profile {req.initiatorProfileId.slice(0, 8)}</span>
          </ProfileCardTrigger>
          <div className="connection-requests__actions">
            <button
              className="connection-requests__btn connection-requests__btn--primary"
              disabled={busyId === req.id}
              onClick={() => act(req.id, accept)}
            >
              Accept
            </button>
            <button
              className="connection-requests__btn"
              disabled={busyId === req.id}
              onClick={() => act(req.id, decline)}
            >
              Decline
            </button>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default ConnectionRequests;
